"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.leadSubMenu = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
const leadSubMenu = exports.leadSubMenu = [{
  path: '/leads/list',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/leads/list.vue'))),
  name: 'lead',
  meta: {
    title: 'leadManagement.lead.title',
    noCache: true,
    icon: 'guide',
    roles: ['System Admin', 'Super Admin', 'Sales Coordinator', 'Admin']
  }
}, {
  path: '/leads/add',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/leads/manage.vue'))),
  name: 'Add Lead',
  props: {
    isEdit: false
  },
  meta: {
    title: 'leadManagement.lead.manage',
    noCache: true,
    activeMenu: '/leads/list',
    hidden: true
  }
}, {
  path: '/leads/edit/:id(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/leads/manage.vue'))),
  name: 'Edit Lead',
  props: {
    isEdit: true
  },
  meta: {
    title: 'leadManagement.lead.manage',
    noCache: true,
    activeMenu: '/leads/list',
    hidden: true
  }
}, {
  path: '/leads/quote/:id(\\d+)',
  component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/leads/quote.vue'))),
  name: 'Quote Lead',
  props: {
    isEdit: true
  },
  meta: {
    title: 'leadManagement.lead.quote',
    noCache: true,
    activeMenu: '/leads/list',
    hidden: true
  }
}
// {
//   path: '/leads/sample/:id(\\d+)',
//   component: () => import('@/views/follow-ups/sampleFollowUpDetails.vue'),
//   name: 'Sample Follow-up',
//   props: {
//     isEdit: true
//   },
//   meta: {
//     title: 'leadManagement.sample.title',
//     noCache: true,
//     activeMenu: '/leads/list',
//     hidden: true
//   }
// }
];